/*
* Created on Mar 03, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/

import {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
// import DomPurify from 'dompurify';

const TextInputComponent = ({label, field_name, input, setInput, place_holder, children, format, validation, disabled, foramtError, ...props}) => {
    const [showError, setShowError] = useState(false);
    const [errMessage, setErrMessage] = useState();
    const {t} = useTranslation()

    const onChange = (e) => {
        let err = '';
        if (input[field_name].required && e.target.value === '') {
            err = t('@This field is Required!@');
            setShowError(true);
        }
        else {
            err = '';
            setShowError(false);
        }

        if (err === '' && format) {
            if (e.target?.value && e.target.value !== '') {
                const valid = e.target.value.match(new RegExp(format));
                if (!valid) {
                    setShowError(true);
                    err = foramtError ? foramtError : t('@Invalid format@');
                }
            }
        }
        if (err === '' && validation) {
            const errMsg = validation(e);
            if (errMsg?.length > 0) {
                setShowError(true);
                err = errMsg
            }
        }
        setErrMessage(err);

        setInput((prevInput) => {
            prevInput[field_name] = {
                ...prevInput[field_name],
                value: e.target.value,
                error: err
            }
            return {...prevInput}
        });
    }

    useEffect(()=>{
        if (input[field_name]?.error) {
            setShowError(true)
            setErrMessage(input[field_name].error)
        }
        else {
            setShowError(false)
            setErrMessage('')
        }
    }, [input[field_name]?.error])


    return (
        <div className="form-row">
            <div className={`form-label ${input[field_name]?.required ? 'required' : ''}`}><label>{label}</label></div>
            <div className="form-field">
                <input type="text"
                       {...props}
                       className={`${showError ? 'invalid' : ''} ${disabled ? 'color-gray-light' : ''}`}
                       placeholder={place_holder}
                       // value={DomPurify.sanitize(input[field_name]?.value) || ''}
                       value={input[field_name]?.value || ''}
                       onChange={(e) => onChange(e)}
                       disabled={disabled}
                       // onBlur={(e) => onChange(e)}
                />
                {children}
                <div className={`error-msg ${showError ? '': 'hide'}`}>{errMessage}</div>
            </div>
        </div>
    );
};

export default TextInputComponent;